export const predefinedPatterns = {
  uuid: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  url: /^(https?):\/\/[^\s$.?#].[^\s]*$/i,
  number: /^-?\d+(\.\d+)?$/,
  integer: /^-?\d+$/,
  positiveInt: /^\d+$/,
  boolean: /^(true|false)$/,
  alphanumeric: /^[a-z0-9]+$/i,
  hex: /^[0-9a-fA-F]+$/,
  base64: /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/,
  jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/,
  semver: /^(\d+\.)?(\d+\.)?(\*|\d+)(-[a-z0-9-.]+)?$/i,
  cron: /^(\*|([0-9]|[1-5][0-9]))(\s+(\*|([0-9]|1[0-9]|2[0-3]))){4}$/,
  ip: /^(?:\d{1,3}\.){3}\d{1,3}$/,
  ipv6: /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/,
  hostname: /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z]{2,})+$/,
} as const;

export type PredefinedPatternKey = keyof typeof predefinedPatterns;
